import { GridApi, IRowNode } from 'ag-grid-community';
import { useMutation } from '@apollo/client';
import {
	alephToast, NotificationToast, NotificationType,
} from '@aleph/shared-components';
import { captureException } from '@sentry/react';
import { SpotifyLevel } from 'wb-spotify/app/routes/superGrid/utils';
import { DeleteEntitiesDocument } from 'wb-spotify/graphql/generated';

const useDeleteBulkAction = (gridApi: GridApi | null) => {
	const [deleteEntities, { loading }] = useMutation(DeleteEntitiesDocument);

	const onDelete = async (rowNodes: IRowNode[]) => {
		try {
			await deleteEntities({
				variables: {
					// ads: rowNodes.filter(
					// 	rowNode => rowNode.data.level === SpotifyLevel.AD,
					// ).map(rowNode => ({ adHash: rowNode.data.id, adId: rowNode.data.id })),
					groups: rowNodes.filter(
						rowNode => rowNode.data.level === SpotifyLevel.GROUP,
					).map(rowNode => ({ groupHash: rowNode.data.id, groupId: rowNode.data.id })),
					campaigns: rowNodes.filter(
						rowNode => rowNode.data.level === SpotifyLevel.CAMPAIGN,
					).map(rowNode => ({ campaignHash: rowNode.data.id, campaignId: rowNode.data.id })),
				},
			});

			rowNodes.forEach(rowNode => {
				gridApi?.applyServerSideTransaction({
					route:  rowNode.getRoute()?.slice(0, -1),
					remove: [rowNode.data],
				});
			});

			alephToast(
				<NotificationToast
					type={NotificationType.Success}
					title={
						<div>
							Successfully deleted
							&nbsp;
							<strong>{rowNodes.length}</strong>
							&nbsp;
							{rowNodes.length === 1 ? 'entity' : 'entities'}.
						</div>
					}
				/>,
			);
		} catch (e) {
			console.log(e);
			captureException(e);
			alephToast(
				<NotificationToast
					type={NotificationType.Error}
					title="Deleting entities failed. We have been notified."
				/>,
			);
		}
	};

	return {
		onDelete,
		loading,
	};
};

export default useDeleteBulkAction;
